<template>
	<UserRegistrationLayout class="delete-account-container">
		<div class="delete-account" v-if="!isLoading">
			<div v-if="!errorMsg">Sad to see you go... your workspace is being deleted</div>
			<div v-else>
				<div>Something went wrong.</div>
				<div>{{ errorMsg }}</div>
			</div>
		</div>
		<AppLoader v-else />
	</UserRegistrationLayout>
</template>

<script>
import UserRegistrationLayout from './userRegistration/UserRegistrationLayout';
import { acceptDeleteAccount } from '@/store/modules/account/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import ErrorHandlingService from '@/utils/error-handling-service';

export default {
	name: 'DeleteWorkspaceConformation',
	components: { UserRegistrationLayout },
	props: {
		account: { type: String },
	},

	methods: {
		...mapActionsShorthand({ acceptDeleteAccount }),
	},
	async mounted() {
		this.isLoading = true;
		if (this.account) {
			try {
				await this.acceptDeleteAccount({ account: this.account });
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				this.errorMsg = ErrorHandlingService.extractErrorMessage(err) || 'something went wrong';
			}
		} else {
			this.isLoading = false;
			this.errorMsg = 'Missing parameters for deleting account, please try to start this flow again from the settings page';
		}
	},
	data() {
		return {
			isLoading: true,
			errorMsg: null,
		};
	},
};
</script>

<style scoped lang="scss">
.change-owner {
	width: 300px;
}
</style>
